import { Tooltip } from '@ps/web-fusion-components';
import type {
  SecondaryNavigationBlock,
  SupportNavigationBlock
} from '@ps/web-martech-cms-types/SiteHeader';
import classNames from 'clsx';
import { useCallback } from 'react';
import { type NavLinkProps, useLocation } from 'react-router-dom';

import { CMSResolverLink } from '@swf/cms';

import styles from './SideMenu.scss';

type SideMenuLayout = 'horizontal' | 'vertical';

interface SideMenuProps {
  items: SupportNavigationBlock[] | SecondaryNavigationBlock[];
  className?: string;
  layout?: SideMenuLayout;
}

const SideMenu: React.FC<SideMenuProps> = ({ items, className, layout = 'vertical' }) => {
  const { pathname } = useLocation();

  const isActive = useCallback(
    (url?: string): NavLinkProps['isActive'] =>
      (_, { pathname }) =>
        url ? pathname.startsWith(url) : false,
    []
  );

  return (
    <div
      className={classNames(
        styles.container,
        { [styles.containerHorizontal]: layout === 'horizontal' },
        className
      )}
    >
      <ul
        className={classNames(styles.list, {
          [styles.listHorizontal]: layout === 'horizontal'
        })}
      >
        {items.map((item, id) => (
          <Tooltip
            placement={layout === 'horizontal' ? 'bottom' : 'right'}
            key={id}
            delay={0}
            closeDelay={0}
            className={styles.tooltip}
          >
            <li
              className={classNames(styles.menuItem, {
                [styles.activeMenuItem]: item.url && pathname.startsWith(item.url)
              })}
            >
              <CMSResolverLink
                isActive={isActive(item.url)}
                activeClassName={styles.active}
                className={classNames(styles.resolverLink, {
                  [styles.resolverLinkNoBackground]: layout === 'horizontal'
                })}
                showTitle={false}
                {...item}
              />
            </li>
            <p>{item.title}</p>
          </Tooltip>
        ))}
      </ul>
    </div>
  );
};
export default SideMenu;
